import script from "./SpMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SpMenu.vue?vue&type=style&index=0&id=4f262e41&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f262e41"]])

export default __exports__